import React from "react";
import { useTranslation } from "react-i18next";
import TitleSubtitle from "../../components/common/TitleSubtitle";
import { generateQRCodeFromText } from "../../api/support";
import TextInput from "../../components/ui/TextInput";
import ProductPickerModal from "../../components/modals/ProductPickerModal";
import Icon from "../../components/common/Icon";
import adminSurface from "../../components/layouts/AdminSurface.module.css";
import studio from "../../styles/studioPage.module.css";

const QRCodeGeneration: React.FC = () => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    const [loading, setLoading] = React.useState<boolean>(false);
    const [text, setText] = React.useState<string>("");

    const [QRCode, setQRCode] = React.useState<string>("");
    const [isProductPickerModalOpen, setIsProductPickerModalOpen] = React.useState<boolean>(false);

    const handleGenerate = async () => {
        const token = localStorage.getItem("token");
        if (!token) {
            console.error("Token not found");
            return;
        }

        if (!text) {
            console.error("Aucun text");
            return;
        }

        setLoading(true);

        const response = await generateQRCodeFromText(token, text);
        setQRCode(response.url);
        setLoading(false);
    };

    const handleProductSelect = (productId: string) => {
        const productUrl = `https://rewindstories.app.link/${productId}`;
        setText(productUrl);
        setIsProductPickerModalOpen(false);
    };

    return (
        <div className={adminSurface.pageContent}>
            <div className={`${studio.pageTitle} ${adminSurface.pageTitle}`}>
                <TitleSubtitle title={t("qrCodeGeneration")} subtitle={t("qrCodeGenerationSubtitle")} />
            </div>

            <div className={adminSurface.supportQrForm}>
                <div className={adminSurface.supportQrRow}>
                    <TextInput
                        placeholder={t("enterTextToQRCode")}
                        onChange={(value) => setText(value.target.value)}
                        value={text}
                        disabled={false}
                    />
                    <button
                        className={adminSurface.qrCodeHelperButton}
                        onClick={() => setIsProductPickerModalOpen(true)}
                    >
                        {t("selectFromProducts")}
                    </button>
                </div>

                <div>
                    <button className={adminSurface.addButton} onClick={handleGenerate} disabled={!text}>
                        {t("generate")}
                    </button>
                </div>

                {loading && <p style={{ marginTop: 24 }}>{t("generating")}...</p>}

                {!loading && QRCode && (
                    <div className={adminSurface.supportDl}>
                        <div className={adminSurface.supportDlLbl}>{t("downloadFile")}:</div>
                        <div className={adminSurface.supportDlRow}>
                            <a
                                href={QRCode}
                                download
                                target="_blank"
                                rel="noopener noreferrer"
                                className={adminSurface.supportBtnDl}
                            >
                                <Icon name="ic-download" className="ic" size={17} />
                                {t("downloadQRCode")}
                            </a>
                        </div>
                    </div>
                )}
            </div>

            <ProductPickerModal
                isOpen={isProductPickerModalOpen}
                onClose={() => setIsProductPickerModalOpen(false)}
                onProductSelect={handleProductSelect}
            />
        </div>
    );
};

export default QRCodeGeneration;
